import { config } from '@/pageConfig/claims/nl/en';
import { ClaimsPageTemplate } from '@/pageTemplate/ClaimsPageTemplate';

export default function ClaimsPage() {
  return <ClaimsPageTemplate config={config} />;
}
